import axios from "axios";

const PRESENCAS_URL =
  `${process.env.REACT_APP_API_URL}/presencas` ||
  "http://localhost:3001/presencas";

export async function getPresencas(token, pdata1, pdata2) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(
    `${PRESENCAS_URL}?data1=${pdata1}&data2=${pdata2}`,
    { headers }
  );
  return response.data;
}

export async function calcPresencas(token, pdata1, pdata2) {
  const headers = {
    authorization: token,
  };
  const url = `${PRESENCAS_URL}/calcular?data1=${pdata1}&data2=${pdata2}`;

  //console.log("URL: ", url);
  const response = await axios.get(url, {
    headers,
  });
  /*console.log("SERVICE RESPONSE: ", response.data);*/

  return response.data;
}
